import Emoji from '@src/routes/club/emoji/types/Emoji'

export default class EmojiData {
  default: {
    selected: Emoji | null
    available: Emoji[]
  }
  global: {
    selected: Emoji | null
    available: Emoji[]
  }
  japan: {
    selected: Emoji | null
    available: Emoji[]
  }

  constructor (attributes = undefined) {
    if (attributes) {
      Object.assign(this, attributes)
    } else {
      this.default = {
        selected: null,
        available: []
      }
      this.global = {
        selected: null,
        available: []
      }
      this.japan = {
        selected: null,
        available: []
      }
    }
  }

}
